import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user, isAdmin } = useAuth();

  const navigationItems = [
  { label: 'Home', path: '/home-landing' },
  { label: 'Projects', path: '/projects' },
  { label: 'Blog', path: '/blog-posts' },
  { label: 'About', path: '/about' }];


  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location?.pathname]);

  return (
    <>
      <header className="nav-header">
        <div className="nav-container">
          <Link to="/home-landing" className="nav-logo">
            <span>Joe Graziano</span>
          </Link>

          <nav className="nav-menu">
            {navigationItems?.map((item) =>
            <Link
              key={item?.path}
              to={item?.path}
              className={`nav-link ${isActivePath(item?.path) ? 'active' : ''}`}>

                {item?.label}
              </Link>
            )}
          </nav>

          <button
            className="nav-mobile-toggle"
            onClick={handleMobileMenuToggle}
            aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isMobileMenuOpen}>

            <Icon
              name={isMobileMenuOpen ? 'X' : 'Menu'}
              size={24}
              color="var(--color-foreground)" />

          </button>
        </div>
      </header>
      <div className={`nav-mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        {navigationItems?.map((item) =>
        <Link
          key={item?.path}
          to={item?.path}
          className={`nav-mobile-link ${isActivePath(item?.path) ? 'active' : ''}`}
          onClick={handleMobileLinkClick}>

            {item?.label}
          </Link>
        )}
      </div>
    </>
  );

};

export default Header;